const AWS = require('aws-sdk')
const axios = require('axios')
import auth from './auth';

const regions = ['eu-west-1', 'eu-west-2', 'us-west-1'];
  
AWS.config.update({
    region: 'eu-west-1',
    credentials : new AWS.CognitoIdentityCredentials({
        IdentityPoolId: 'eu-west-1:446e6f43-1eb8-4a42-8f9f-4519ee0e8fac',
        IdentityId: auth.auth.getSignInUserSession().getIdToken(),
        Region: 'eu-west-1',
        Logins: {
            'cognito-idp.eu-west-1.amazonaws.com/eu-west-1_SXjzhKGOq': auth.auth.signInUserSession.getIdToken().getJwtToken()
        }
    })
});
let ec2 = new AWS.EC2();
let cloudwatch = new AWS.CloudWatch();

function processInstance(instance) {
    instance["Name"] = instance.Tags.find(t => t.Key == "Name").Value;

    let clientsString = instance.Tags.find(t => t.Key == "Clients");
    let clients = [];
    if(clientsString != null)
        clients =clientsString.Value.split(",");

    instance["Clients"] = clients;

    instance["Environment"] = typeof(instance.Tags.find(t => t.Key == "Environment")) != "undefined" ? instance.Tags.find(t => t.Key == "Environment").Value : "";
}

export class serverStore 
{
    
    getServers() {
        return new Promise((resolve, reject) => {
            AWS.config.update({ region: regions[0]});
            ec2 = new AWS.EC2();

            ec2.describeInstances((error, data) => {
                if (error) reject(error)

                let instances = [];
                for(var res of data.Reservations) {
                    instances = [...instances, ...res.Instances]
                }

                for(let instance of instances) {
                    processInstance(instance);
                    instance["Region"] = regions[0];
                }

                AWS.config.update({ region: regions[1]});
                ec2 = new AWS.EC2();

                ec2.describeInstances((error, data) => {
                    if (error) reject(error)

                    for(var res of data.Reservations) {
                        instances = [...instances, ...res.Instances]
                        
                        for(let instance of res.Instances) {
                            processInstance(instance);
                            instance["Region"] = regions[1];
                        }
                    }
    
                    resolve(instances)
                })
            })
        });
    }

    getServer(instanceId, region) {
        return new Promise((resolve, reject) => {
            AWS.config.update({ region: region});
            ec2 = new AWS.EC2();

            ec2.describeInstances({ InstanceIds : [instanceId] },
                (error, data) => {
                    if (error) reject(error)

                    let instances = [];
                    for(var res of data.Reservations) {
                        instances = [...instances, ...res.Instances]
                    }

                    for(let instance of instances) {
                        processInstance(instance);
                    }
                    resolve(instances[0])
                });
        });
    }

    stopServer(instanceId) {
        ec2.stopInstances({ InstanceIds : [instanceId]}, (error, data) => {
            return new Promise((resolve, reject) => {
                if(error) reject(error);

                resolve(data);
            })
        });
    }

    startServer(instanceId) {
        ec2.startInstances({ InstanceIds : [instanceId]}, (error, data) => {
            return new Promise((resolve, reject) => {
                if(error) reject(error);

                resolve(data);
            })
        });
    }

    rebootServer(instanceId) {
        ec2.rebootInstances({ InstanceIds : [instanceId]}, (error, data) => {
            return new Promise((resolve, reject) => {
                if(error) reject(error);

                resolve(data);
            })
        });
    }

    getServerCpuState(instanceId) {
        return new Promise((resolve, reject) => {
            var params = { 
                OutputFormat: "png",
                "MetricWidget": JSON.stringify({
                    width:600,
                    height:395,
                    metrics: [
                        [
                            "AWS/EC2",
                            "CPUUtilization",
                            "InstanceId",
                            instanceId,
                            {
                                stat: "Average"
                            }
                        ]
                    ],
                    "period":60,
                    "stacked":false
                })
            }

            cloudwatch.getMetricWidgetImage(params, (error, data) => {
                if(error) reject(error);
                
                resolve(data.MetricWidgetImage);
            })
        })
    }

    recycleAppPool(ip, siteName) {
        var jwt = auth.auth.signInUserSession.getIdToken().getJwtToken();
        axios.get(
            `https://lr19er710e.execute-api.eu-west-1.amazonaws.com/Production/websites/recycle?siteName=${siteName}&ip=${ip}`,
            {
                headers: {
                    authorization: `Bearer ${jwt}`
                }
            }).then(() => {

            })
    }

    getWebSites(ip) {
        var jwt = auth.auth.signInUserSession.getIdToken().getJwtToken();
        return new Promise((resolve, reject) => { 
            axios.get(
            `https://lr19er710e.execute-api.eu-west-1.amazonaws.com/Production/websites?ip=${ip}`,
            {
                headers: {
                    authorization: `Bearer ${jwt}`
                }
            }).then((response) => {
                resolve(response.data);
            },
            (error) => {
                reject(error);
            })
        });
    }

    getServerSupportContacts() {
        var jwt = auth.auth.signInUserSession.getIdToken().getJwtToken();
        return new Promise((resolve, reject) => { 
            axios.get(
            `https://lr19er710e.execute-api.eu-west-1.amazonaws.com/Production/contacts`,
            {
                headers: {
                    authorization: `Bearer ${jwt}`
                }
            }).then((response) => {
                resolve(response.data);
            },
            (error) => {
                reject(error);
            })
        });
    }
}

export default new serverStore();